/**
 * @generated SignedSource<<02bf357bad28d688b353342617d36e4c>>
 * @relayHash 4785a33fdfd513319743ba4959e52429
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad6c2be41b901e938ece972c44a679cf49cd60f72bd1f6a311e5ebc499dfdee6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlassianNavigationNav4Query$variables = {
  cloudId: string;
  isAnonymous: boolean;
};
export type AtlassianNavigationNav4Query$data = {
  readonly jira?: {
    readonly navigationUIState: {
      readonly isLeftSidebarCollapsed: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData" | "Nav4ProfileNew">;
};
export type AtlassianNavigationNav4Query = {
  response: AtlassianNavigationNav4Query$data;
  variables: AtlassianNavigationNav4Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAnonymous"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "isLeftSidebarCollapsed"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AtlassianNavigationNav4Query",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "Nav4ProfileNew"
          },
          {
            "kind": "FragmentSpread",
            "name": "Nav4NotificationsData"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AtlassianNavigationNav4Query",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraNavigationUIStateUserProperty",
                "kind": "LinkedField",
                "name": "navigationUIState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  },
                  (v3/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "unseenNotificationCount"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ad6c2be41b901e938ece972c44a679cf49cd60f72bd1f6a311e5ebc499dfdee6",
    "metadata": {},
    "name": "AtlassianNavigationNav4Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "49077d00da8f017f20fc330cb527243f";

export default node;
